import { isObjectEmpty } from "../utils/general";

export function validateApplicationForm(
  key,
  jsonData,
  applicationJsonData,
  transcriptJsonData,
  couponsExist,
  disabledSaveValue,
) {
  const isNullOrEmpty = (value) =>
    value === null || value === "" || value === undefined;
  if (key === 0) {
    return !jsonData.usb_inititalagreement;
  }
  if (key === 1) {
    // Define required fields
    const requiredFields = [
      "usb_visastatus",
      "_usb_countryofcitizenship_value",
      "_usb_countryofbirth_value",
      "_ses_countryofresidence_value",
      "usb_previouslyapplied",
      "address1_line1",
      "address1_city"
    ];

    // Check if all required fields are filled
    const allRequiredFieldsFilled = requiredFields.every(
      (field) => !isNullOrEmpty(jsonData[field]),
    );

    // Additional conditions for specific visa statuses
    const isVisaStatus943240004 =
      jsonData.usb_visastatus === 943240004 ||
      jsonData.usb_visastatus === 943240003 ||
      jsonData.usb_visastatus === 943240002;
    const isVisaStatus943240006 = jsonData.usb_visastatus === 943240006;

    const visaFields = ["usb_passport", "usb_passportexpirydate"];
    const passportFields = ["usb_passport", "usb_passportexpirydate"];

    const allVisaFieldsFilled = visaFields.every(
      (field) => !isNullOrEmpty(jsonData[field]),
    );
    const allPassportFieldsFilled = passportFields.every(
      (field) => !isNullOrEmpty(jsonData[field]),
    );

    const residenceCountries = [
      "c3f83658-1116-ee11-9cbe-000d3af4f17d", // Canada
      "01f93658-1116-ee11-9cbe-000d3af4f17d", // Etats-Unis
    ];
    const isResidenceCountryFilled = residenceCountries.includes(
      jsonData._ses_countryofresidence_value,
    );

    // Address requirements:
    // - Always require address1_line1 and address1_city
    // - If Canada/US, also require state/province and postal code
    const canadaUsExtraFields = [
      "ses_stateorprovince",
      "address1_postalcode",
    ];
    const allResidenceFieldsFilled = isResidenceCountryFilled === [...canadaUsExtraFields].every(
      (field) => !isNullOrEmpty(jsonData[field]),
    );

    let dateError = false;
    if (
      jsonData.usb_studypermitexpirydate !== "" &&
      jsonData.usb_studypermitexpirydate !== null &&
      jsonData.usb_studypermitissuedate !== "" &&
      jsonData.usb_studypermitissuedate !== null
    ) {
      dateError =
        new Date(jsonData.usb_studypermitexpirydate) <
        new Date(jsonData.usb_studypermitissuedate);
    }
    // Combine all conditions
    let allConditionsMet =
      allRequiredFieldsFilled &&
      (!isVisaStatus943240004 || allVisaFieldsFilled) &&
      (!isVisaStatus943240006 || allPassportFieldsFilled) &&
      (!isResidenceCountryFilled || allResidenceFieldsFilled) &&
      jsonData.usb_passportexpirydate !== "Invalid date";


    if (
      jsonData.usb_visastatus === 943240003 ||
      jsonData.usb_visastatus === 943240004
    ) {
      allConditionsMet = allConditionsMet && !dateError;
    }

    const nameRegex = /^\p{Lu}[\p{L}\p{M}' -]*$/u;
    if (isNullOrEmpty(jsonData.firstname) || !nameRegex.test(jsonData.firstname)) {
      allConditionsMet = false;
    } else if (isNullOrEmpty(jsonData.lastname) || !nameRegex.test(jsonData.lastname)) {
      allConditionsMet = false;
    } else if ((jsonData.ses_preferredname !== "" &&
      jsonData.ses_preferredname !== null &&
      jsonData.ses_preferredname !== undefined) && !nameRegex.test(jsonData.ses_preferredname)) {
      allConditionsMet = false;
    } else if ((jsonData.middlename !== "" &&
      jsonData.middlename !== null &&
      jsonData.middlename !== undefined) && !nameRegex.test(jsonData.middlename)
    ) {
      allConditionsMet = false;
    } else if ((jsonData.usb_formername !== "" &&
      jsonData.usb_formername !== null &&
      jsonData.usb_formername !== undefined) && !nameRegex.test(jsonData.usb_formername)
    ) {
      allConditionsMet = false;
    } else if ((jsonData.usb_maidenname !== "" &&
      jsonData.usb_maidenname !== null &&
      jsonData.usb_maidenname !== undefined) && !nameRegex.test(jsonData.usb_maidenname)
    ) {
      allConditionsMet = false;
    } else if (
      jsonData.usb_previouslyapplied === true &&
      isNullOrEmpty(jsonData.usb_mostrecentpreviousapplicationyear)
    ) {
      allConditionsMet = false;
    } else if (
      jsonData.usb_previouslyapplied === true &&
      isNullOrEmpty(jsonData.usb_currentstudent)
    ) {
      allConditionsMet = false;
    } 

    const hasPhoneNumber =
      !isNullOrEmpty(jsonData.mobilephone) ||
      !isNullOrEmpty(jsonData.home2) ||
      !isNullOrEmpty(jsonData.business2);

    if (!hasPhoneNumber) {
      allConditionsMet = false;
    }
    return !allConditionsMet;
  }
  if (key === 2) {
    const {
      birthdate,
      gendercode,
      mshied_firstgeneration,
      usb_nativelanguage,
      usb_indigenousancestry,
      usb_indigenousancestrytype,
    } = jsonData;

    // Function to validate the birthdate format and check if it's in the past
    const isValidBirthdate = (date) => {
      const regex = /^\d{4}-\d{2}-\d{2}$/;
      if (!regex.test(date)) {
        return false; // Invalid format
      }
      const today = new Date();
      const birthdateObj = new Date(date);
      return birthdateObj < today; // Ensure birthdate is in the past
    };

    const hasRequiredFields =
      birthdate !== null &&
      isValidBirthdate(birthdate) && // Check if birthdate is valid and in the past
      gendercode !== null &&
      mshied_firstgeneration !== null &&
      usb_nativelanguage !== null &&
      usb_nativelanguage !== "";
    if (
      !hasRequiredFields ||
      (usb_indigenousancestry === 1 && usb_indigenousancestrytype === null)
    ) {
      return true;
    } else {
      return false;
    }
  }
  if (key === 3) {
    const usbVisaStatus = [943240000, 943240001, 943240005];
    let requiredFields = [
      "_ses_academicperiodid_value",
      "_ses_certificationprogramid_value",
    ];

    if (usbVisaStatus.includes(jsonData.usb_visastatus)) {
      requiredFields.push("usb_admissioncategory");
    }

    const allFieldsFilled = requiredFields.every(
      (field) =>
        applicationJsonData[field] !== null &&
        applicationJsonData[field] !== "",
    );
    return !allFieldsFilled;
  }
  if (key === 4) {
    const requiredFields = [
      "usb_graduatefromhighschoolincurrentyear",
      "usb_schooltype",
      "start_date_month",
      "start_date_year",
      "end_date_month",
      "end_date_year",
      "usb_graduate",
    ];

    const allFieldsFilled = requiredFields.every(
      (field) =>
        applicationJsonData[field] !== null &&
        applicationJsonData[field] !== "" &&
        applicationJsonData[field] !== undefined,
    );

    if (!allFieldsFilled) {
      return true;
    }

    // Check for specific conditions
    if (
      applicationJsonData.usb_graduatefromhighschoolincurrentyear &&
      (applicationJsonData.usb_metnumber === null ||
        applicationJsonData.usb_metnumber === "" ||
        !/^\d{9}$/.test(applicationJsonData.usb_metnumber))
    ) {
      return true;
    }

    const schoolTypeConditions = [
      {
        type: 943240000,
        field: "usb_schoolname0",
      },
      {
        type: 943240001,
        field: "usb_schoolname1",
      },
      {
        type: 943240002,
        field: "usb_schoolname2",
      },
    ];

    const schoolTypeCheck = schoolTypeConditions.some(
      ({ type, field }) =>
        applicationJsonData.usb_schooltype === type &&
        (applicationJsonData[field] === undefined ||
          applicationJsonData[field] === null ||
          applicationJsonData[field] === ""),
    );

    if (schoolTypeCheck) {
      return true;
    }

    if (
      applicationJsonData.usb_graduate &&
      (applicationJsonData.usb_graduationdate === undefined ||
        applicationJsonData.usb_graduationdate === null ||
        applicationJsonData.usb_graduationdate === "null")
    ) {
      return true;
    }

    return false;
  }
  if (key === 5 && jsonData === null) {
    const isCurrentdegreestatus =
      applicationJsonData.usb_currentdegreestatus === 943240001;
    let requiredFields = [
      "usb_educationlevel",
      "usb_currentdegreestatus",
      "usb_schooltype",
      "start_date_month",
      "start_date_year",
    ];
    if (isCurrentdegreestatus) {
      requiredFields.push("end_date_month");
      requiredFields.push("end_date_year");
    }

    const allFieldsFilled = requiredFields.every(
      (field) => !isNullOrEmpty(applicationJsonData[field]),
    );

    if (!allFieldsFilled) return true;

    const schoolTypeConditions = [
      { type: 943240003, field: "usb_secondaryschoolname0" },
      { type: 943240004, field: "usb_secondaryschoolname1" },
    ];

    const schoolTypeCheck = schoolTypeConditions.some(
      ({ type, field }) =>
        applicationJsonData.usb_schooltype === type &&
        isNullOrEmpty(applicationJsonData[field]),
    );

    if (schoolTypeCheck) return true;



    if (
      applicationJsonData.usb_currentdegreestatus === 943240001 &&
      isNullOrEmpty(applicationJsonData.usb_graduationdate)
    ) {
      return true;
    }

    return false;
  }

  if ((key === 5 || key === 6) && disabledSaveValue) {
    return true;
  }
  if (
    key === 6 &&
    isObjectEmpty(transcriptJsonData?.length) > 0 &&
    jsonData === null
  ) {
    const requiredFields = ["usb_classcategory", "usb_level", "usb_grade"];
    const allFieldsFilled = requiredFields.every(
      (field) => !isNullOrEmpty(transcriptJsonData?.[field]),
    );
    if (!allFieldsFilled) return true;
    if (
      transcriptJsonData.usb_classcategory === 943240034 &&
      isNullOrEmpty(transcriptJsonData.usb_otherclasscategory)
    ) {
      return true;
    }

    const grade = Number(transcriptJsonData.usb_grade);
    if (!Number.isInteger(grade) || grade < 0 || grade > 100) {
      return true;
    }
    return false;
  }

  if (key === 7) {
    const requiredFields = ["applicationOptions"];
    const allFieldsFilled = requiredFields.every(
      (field) =>
        applicationJsonData[field] !== null &&
        applicationJsonData[field] !== "" &&
        applicationJsonData[field] !== undefined,
    );
    if (!allFieldsFilled) return true;

    if (
      applicationJsonData.applicationOptions === "Coupon" &&
      isNullOrEmpty(applicationJsonData.usb_couponcode)
    ) {
      return true;
    }

    if (
      applicationJsonData.applicationOptions === "Coupon" &&
      (couponsExist === false || couponsExist === null)
    ) {
      return true;
    }
    return false;
  }

  if (key === 8) {
    const requiredFields = [
      "amountdue",
      "nameOnCard",
      "emailaddress1",
      "creditcard",
      "expiration",
      "securitycode",
    ];
    const allFieldsFilled = requiredFields.every(
      (field) => jsonData[field] !== null && jsonData[field] !== "",
    );

    // return !allFieldsFilled;
    if (!jsonData.paymentdone) return true;
    return false;
  }

  if (key === 9) {
    const requiredFields = [
      "usb_termsaccepted",
      "usb_esignature",
      "usb_applicationsubmitteddate",
    ];
    const allFieldsFilled = requiredFields.every(
      (field) =>
        applicationJsonData[field] !== null &&
        applicationJsonData[field] !== "" &&
        applicationJsonData[field] !== undefined,
    );

    if (!allFieldsFilled) return true;
    if (applicationJsonData.usb_termsaccepted === false) return true;

    return false;
  }
}
